import React from "react";
import { Lock, LogOut, Mail } from "lucide-react";

/**
 * Full-screen block that replaces the entire app for students whose
 * mentorship is pending, expired, blocked or has been removed. Only the
 * logout button and a mentor-contact CTA remain reachable.
 */
export default function AccessBlockedPage({ message, user, onLogout }) {
  return (
    <div
      data-testid="access-blocked-screen"
      className="min-h-screen bg-[#0B0C10] text-[#F3F4F6] flex items-center justify-center p-6"
    >
      <div className="max-w-md w-full bg-[#14161C] border border-[#282D3D] rounded-2xl p-8 text-center space-y-5 shadow-2xl">
        <div className="w-14 h-14 mx-auto bg-red-500/15 border border-red-500/30 rounded-full flex items-center justify-center">
          <Lock className="w-7 h-7 text-red-400" />
        </div>
        <div className="space-y-1">
          <h1 className="text-xl font-extrabold text-white">
            Acesso bloqueado
          </h1>
          <p className="text-sm text-gray-400 leading-relaxed">
            {message || (
              <>
                Seu acesso ao Modo Caverna ainda não foi aprovado, está
                expirado ou foi removido.
              </>
            )}
          </p>
        </div>

        <div
          data-testid="access-blocked-status"
          className="bg-[#0F1218] border border-[#282D3D] rounded-lg p-3 text-left text-xs space-y-1"
        >
          <div className="flex justify-between">
            <span className="text-gray-500">Email</span>
            <span className="text-gray-200 font-semibold">{user?.email}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-500">Perfil</span>
            <span className="text-gray-200 font-semibold uppercase">
              {user?.role || "aluno"}
            </span>
          </div>
        </div>

        <div className="space-y-2 text-left bg-amber-500/5 border border-amber-500/20 rounded-lg p-3">
          <p className="text-[11px] text-amber-200 leading-snug">
            <strong>O que fazer agora?</strong>
          </p>
          <ul className="text-[11px] text-amber-200/80 space-y-1 list-disc pl-4">
            <li>Fale com o seu mentor para liberar o acesso.</li>
            <li>
              Se já pagou, aguarde a aprovação manual — você receberá uma
              notificação ao ser liberado.
            </li>
            <li>
              Se seu acesso expirou, renove com seu mentor para continuar.
            </li>
          </ul>
        </div>

        <div className="flex flex-col gap-2">
          <a
            data-testid="access-blocked-contact-btn"
            href="https://wa.me/5500000000000"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center justify-center gap-2 w-full py-2.5 rounded-lg bg-[#FF6B00] hover:bg-[#FF8533] text-black font-extrabold text-xs uppercase tracking-wider"
          >
            <Mail className="w-3.5 h-3.5" />
            Falar com meu mentor
          </a>
          <button
            data-testid="access-blocked-signout-btn"
            onClick={onLogout}
            className="inline-flex items-center justify-center gap-2 w-full py-2.5 rounded-lg bg-[#1F2330] hover:bg-[#282F42] border border-[#3E4760] text-white font-bold text-xs uppercase tracking-wider"
          >
            <LogOut className="w-3.5 h-3.5" />
            Sair
          </button>
        </div>
      </div>
    </div>
  );
}
